import harryG from "../images/character/Gryffindor/harry_Gryffindor.png";
import hermioneG from "../images/character/Gryffindor/hermoine_Gryffindor.png";
import hagridG from "../images/character/Gryffindor/hagrid1_Gryffindor.png";
import ronG from "../images/character/Gryffindor/ron_Gryffindor.png";

import cedricH from "../images/character/hufflepuff/cedric_degery_hufflepuff.png";
import newtH from "../images/character/hufflepuff/newt_hufflepuff.png";
import tonksH from "../images/character/hufflepuff/NymphadoraTonks_hufflepuff.png";

import choR from "../images/character/ravenclaw/chochang_ravenclaw.png";
import lunaR from "../images/character/ravenclaw/lunalovegood1_revenclaw.png";
import padmaR from "../images/character/ravenclaw/padmapatil_ravenclaw.png";

import bellatrixS from "../images/character/slytherin/bellatrix_slytherin.png";
import umbridgeS from "../images/character/slytherin/DoloresUmbridge_slytherin.png";
import dracoS from "../images/character/slytherin/Draco_slytherin.png";
import snapeS from "../images/character/slytherin/SeverusSnape_slytherin.png";

export const CHARACTERS_BY_HOUSE = {
  gryffindor: [
    {
      id: "harry",
      name: "Harry Potter",
      description:
        "Fearless in the face of darkness.",
      portrait: harryG,
      stage1IntroLine:
        "Let’s see what you’re made of.",
    },
    {
      id: "hermione",
      name: "Hermione Granger",
      description:
        "Brilliance that turns knowledge into power.",
      portrait: hermioneG,
      stage1IntroLine:
        "Focus. Precision wins this.",
    },
    {
      id: "ron",
      name: "Ron Weasley",
      description:
        "Loyal, impulsive, and always standing his ground.",
      portrait: ronG,
      stage1IntroLine:
        "Alright… let’s not mess this up",
    },
    {
      id: "hagrid",
      name: "Rubeus Hagrid",
      description:
        "Heart as vast as his frame — more tenderness than most expect.",
      portrait: hagridG,
      stage1IntroLine:
        "Go on then — you've got the nerve for this; I can see it plain as day!",
    },
  ],
  hufflepuff: [
    {
      id: "cedric",
      name: "Cedric Diggory",
      description:
        "Honour, fairness, and quiet strength.",
      portrait: cedricH,
      stage1IntroLine:
        "Play fair… and play well.",
    },
    {
      id: "newt",
      name: "Newt Scamander",
      description:
        "Gentle with creatures, powerful in spirit.",
      portrait: newtH,
      stage1IntroLine:
        "Careful aim… gentle control.",
    },
    {
      id: "tonks",
      name: "Nymphadora Tonks",
      description:
        "Unpredictable, bold, and full of heart.",
      portrait: tonksH,
      stage1IntroLine:
        "Let’s make this interesting!",
    },
  ],
  ravenclaw: [
    {
      id: "cho",
      name: "Cho Chang",
      description:
        "Graceful, composed, and precise.",
      portrait: choR,
      stage1IntroLine:
        "Stay calm. You’ve got this.",
    },
   
    {
      id: "luna",
      name: "Luna Lovegood",
      description:
        "Sees magic the world overlooks.",
      portrait: lunaR,
      stage1IntroLine:
        "Just follow the magic you feel.",
    },
    {
      id: "padma",
      name: "Padma Patil",
      description:
        "Sharp mind, steady focus.",
      portrait: padmaR,
      stage1IntroLine:
        "Think before you cast.",
    },
  ],
  slytherin: [
    {
      id: "bellatrix",
      name: "Bellatrix Lestrange",
      description:
        "Chaos, power, and madness in every spell.",
      portrait: bellatrixS,
      stage1IntroLine:
        "Show me chaos.",
    },
    {
      id: "umbridge",
      name: "Dolores Umbridge",
      description:
        "Sweet on the surface… ruthless underneath.",
      portrait: umbridgeS,
      stage1IntroLine:
        "We expect nothing short of proper form... and results that reflect well on the house.",
    },
    {
      id: "draco",
      name: "Draco Malfoy",
      description:
        "Ambition sharp enough to cut through anything.",
      portrait: dracoS,
      stage1IntroLine:
        "Try to keep up.",
    },
    {
      id: "snape",
      name: "Severus Snape",
      description:
        "Cold precision. Absolute control.",
      portrait: snapeS,
      stage1IntroLine:
        "Do not disappoint me.",
    },
  ],
};

export function getCharactersForHouse(houseId) {
  if (!houseId) return [];
  const key = String(houseId).toLowerCase();
  return CHARACTERS_BY_HOUSE[key] ?? [];
}

export function getCharacterByIds(houseId, characterId) {
  if (!characterId) return null;
  const list = getCharactersForHouse(houseId);
  return list.find((c) => c.id === characterId) ?? null;
}
